/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ResourceUpdateRequestTitle } from './resourceUpdateRequestTitle';
import type { ResourceUpdateRequestDescription } from './resourceUpdateRequestDescription';
import type { ResourceUpdateRequestCitation } from './resourceUpdateRequestCitation';
import type { ResourceUpdateRequestUrl } from './resourceUpdateRequestUrl';
import type { ResourceUpdateRequestPosition } from './resourceUpdateRequestPosition';
import type { ResourceUpdateRequestOralExamRelevant } from './resourceUpdateRequestOralExamRelevant';

/**
 * Resource Data for update (put) requests
 */
export interface ResourceUpdateRequest {
  title?: ResourceUpdateRequestTitle;
  description?: ResourceUpdateRequestDescription;
  citation?: ResourceUpdateRequestCitation;
  url?: ResourceUpdateRequestUrl;
  /** New position in the resource list (0-based) */
  position?: ResourceUpdateRequestPosition;
  oralExamRelevant?: ResourceUpdateRequestOralExamRelevant;
}
